import { MonitoringView } from "@/components/MonitoringView";

/** Submenu Monitoring Proyek → Monitoring Vendor (tabel per vendor → proyek) */
export default function MonitoringVendor() { return <MonitoringView group="vendor" />; }
